module.exports = __webpack_public_path__ + "static/media/ExlyManageFeedbackForms_preview.cc1d05c9.png";